<template>
  <div v-if="mytost" class="myjiazailist">
    <Col class="demo-spin-col" span="8">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>{{title}}</div>
      </Spin>
    </Col>
  </div>
</template>

<script>
  export default {
    name:"tos",
    props: {
      title: {
        type: String,
        default: "加载中.."
      }
    },
    data() {
      return {
        mytost:false
      }
    },created(){

    },methods:{
      closetos(){
        this.mytost=false
      },
      showtos(){
        this.mytost=true
      }
    }
  }
</script>

<style scoped lang="stylus">
  .myjiazailist {
    width 100%
    height 100vh
    position fixed
    top 0
    z-index 99
    background rgba(0, 0, 0, 0.07)
    display flex
    align-items center
    justify-content center

    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }

    @keyframes ani-demo-spin {
      from {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(180deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    .demo-spin-col {
      height: 100px;
      width 140px
      position: relative;
      border: 1px solid #eee;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/mytoast.vue